(function (module) {
    'use strict';

    module.config(['formlyConfigProvider', (formlyConfigProvider) => {
        formlyConfigProvider.setType({
            name: 'async-select',
            extends: 'select',
            wrapper: 'async-select-wrapper',
            defaultOptions: {
                templateOptions: {
                    options: [],
                    valueProp: 'value',
                    labelProp: 'label',
                    required: true
                }
            },
            controller: ['$scope', 'Integration', function ($scope, Integration) {
                const provider = $scope.options.data.providerName;
                if (!provider) {
                    console.error(`No provider found in angular-formly field data: ${JSON.stringify($scope.options)}`);
                } else {
                    Integration.find({
                            filter: {
                                where: { provider },
                                fields: ['id', 'profile']
                            }
                        })
                        .$promise
                        .then((data) => {
                            $scope.to.options = data.map((i) => {
                                return {
                                    value: i.id,
                                    label: i.profile.displayName
                                };
                            });
                        });
                }
            }]
        });
    }]);
})(angular.module('rocket.components'));

